import { RegistrationStepsNav } from 'app/components/shared/RegistrationStepsNav'
import { Base } from 'app/components/ui/Base'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { protectedRoutes } from 'app/routing/routes'
import React, { useState } from 'react'
import styled from 'styled-components'

import { DocumentsRegistrationThanks } from './DocumentRegistrationThanks'
import { DocumentsRegistrationSteps } from './DocumentsRegistrationSteps'

export const DocumentsRegistration = (): JSX.Element => {
  const [showThanks, setShowThanks] = useState(false)

  return !showThanks ? (
    <>
      <Base>
        <Container>
          <RegistrationStepsNav
            currentStep={'documents'}
          ></RegistrationStepsNav>
          <HeaderWrapper>
            <Text variant='s24' mb={2}>
              In questa pagina ti chiediamo di fare una foto al fronte e al
              retro della carta d’identità del titolare e caricarla sul sistema.
              {'\n'}Poi dovrai scaricare il modulo anagrafica che hai compilato,
              stamparlo, firmarlo e caricarlo con l’apposito modulo.
              {'\n'}Questa operazione può essere fatta in più momenti, basta che
              ogni volta premi il pulsante SALVA e la prossima volta che
              rientrerai troverai il modulo all’esatto step che hai lasciato.
              {'\n\n'}Se ti accorgi di aver sbagliato un dato inserito nel
              modulo di anagrafica, usa il pulsante qui sotto per modificarlo.
            </Text>
            <Button
              variant='cyan'
              size='lg'
              to={protectedRoutes.userRegistration.path}
            >
              MODIFICA L&apos;ANAGRAFICA
            </Button>
          </HeaderWrapper>
        </Container>
        <DocumentsRegistrationSteps
          onRegistrationCompleted={() => setShowThanks(true)}
        ></DocumentsRegistrationSteps>
      </Base>
    </>
  ) : (
    <DocumentsRegistrationThanks />
  )
}

const HeaderWrapper = styled.div`
  text-align: center;

  max-width: 900px;
  margin-right: auto;
  margin-left: auto;

  margin-top: 3rem;
  margin-bottom: 6rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    margin-top: 6rem;
  }
`
